import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import AuthVerifyScreen from './AuthVerifyScreen';

// ฟังก์ชันตรวจสอบ token หมดอายุ
const isTokenExpired = (token) => {
    if (!token || typeof token !== 'string') return true;
    try {
        const part = token.split('.')[1];
        if (!part) return true;
        const base64 = part.replace(/-/g, '+').replace(/_/g, '/');
        const json = decodeURIComponent(
            atob(base64).split('').map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join('')
        );
        const payload = JSON.parse(json);
        const exp = Number(payload?.exp);
        if (!exp || isNaN(exp)) return true;
        // ให้เวลา buffer 30 วินาที
        return exp < (Math.floor(Date.now() / 1000) - 30);
    } catch (error) {
        console.warn('Token validation error:', error);
        return true;
    }
};

const PublicRoute = ({ children }) => {
    const [loading, setLoading] = useState(true);
    const [shouldRedirect, setShouldRedirect] = useState(false);
    const location = useLocation();

    useEffect(() => {
        setLoading(true);

        const checkToken = () => {
            const token = localStorage.getItem('token');

            if (token && !isTokenExpired(token)) {
                setShouldRedirect(true);
            } else {
                if (token && isTokenExpired(token)) {
                    localStorage.removeItem('token');
                }
                setShouldRedirect(false);
            }
            setLoading(false);
        };

        checkToken();
    }, [location.pathname]);

    if (loading) {
        return (
            <AuthVerifyScreen
                message="กำลังตรวจสอบสถานะเข้าสู่ระบบ"
                subMessage="กรุณารอสักครู่..."
            />
        );
    }

    if (shouldRedirect) {
        return <Navigate to="/memberdata" replace />;
    }

    return children;
};

export default PublicRoute;